import React, {useState, useMemo} from "react";
import "../Styles/Question.css";
import plus from "../../Assets/icons/plus.svg"
import minus from "../../Assets/icons/minus.svg"

const Question = ({question, answer, isLast}) => {
    const [showAnswer, setShowAnswer] = useState(false);

    const handleButtonClick = () => {
        setShowAnswer(!showAnswer)
    };

    const expandButtonImage = useMemo(() => {
        if (showAnswer) {
            return <img className="btn-icon" src={minus} width="15px"/>
        } else {
            return <img className="btn-icon" src={plus} width="15px"/>;
        }
    }, [showAnswer]);

    return (
        <div className={`question-container ${!isLast ? 'container-border' : ''}`}>
            <div className="question-row">
                <p className="question">{question}</p>
                <button className="expand-section-btn" onClick={handleButtonClick}>
                    {expandButtonImage}
                </button>
            </div>
            {showAnswer && (
                <p className="answer">{answer}</p>
            )}
            
        </div>
    
  );
};

export default Question;
